<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 15394 15394"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <circle class="fil0" cx="7697" cy="7697" r="7697"/>
  <g id="_761817608">
   <path class="fil1" d="M6001 4461c0,627 -181,486 942,486l0 912c-239,0 -334,-33 -334,91l0 4527 -456 0 0 1368 3099 0 0 -1368 -456 0 0 -4527c0,-121 -86,-91 -303,-91l0 -912 911 0 0 -577c0,-553 -886,-821 -1489,-821 -668,0 -1914,32 -1914,912z"/>
   <path class="fil1" d="M4087 6709c0,451 607,410 607,31 0,-431 -607,-373 -607,-31z"/>
   <path class="fil1" d="M11592 3823c0,446 608,356 608,0 0,-388 -608,-395 -608,0z"/>
   <path class="fil1" d="M5150 5251c343,0 401,-608 -30,-608 -382,0 -398,608 30,608z"/>
   <path class="fil1" d="M9981 5038c0,343 608,401 608,-30 0,-382 -608,-398 -608,30z"/>
   <path class="fil1" d="M11045 7074c363,0 363,-608 0,-608 -430,0 -426,608 0,608z"/>
   <path class="fil1" d="M11592 7348c0,417 608,371 608,0 0,-373 -608,-422 -608,0z"/>
   <path class="fil1" d="M9981 6254c0,318 608,401 608,-31 0,-378 -608,-420 -608,31z"/>
   <path class="fil1" d="M9283 5616c0,431 607,348 607,30 0,-450 -607,-409 -607,-30z"/>
   <path class="fil1" d="M4087 4431c0,318 607,401 607,-31 0,-378 -607,-420 -607,31z"/>
   <path class="fil1" d="M11592 6193c0,97 19,180 69,235 179,198 539,66 539,-205 0,-405 -608,-360 -608,-30z"/>
   <path class="fil1" d="M10984 5919c497,0 384,-607 61,-607 -178,0 -300,119 -323,284 -20,144 123,323 262,323z"/>
   <path class="fil1" d="M4087 5555c0,393 607,393 607,0 0,-393 -607,-393 -607,0z"/>
   <path class="fil1" d="M3236 4917c0,466 559,406 594,52 37,-388 -594,-446 -594,-52z"/>
   <path class="fil1" d="M3236 3793c0,498 594,385 595,30 0,-378 -595,-403 -595,-30z"/>
   <path class="fil1" d="M5849 5859c363,0 363,-608 0,-608 -422,0 -422,608 0,608z"/>
   <path class="fil1" d="M11592 5008c0,454 608,352 608,0 0,-358 -608,-406 -608,0z"/>
   <path class="fil1" d="M3236 7317c0,475 561,393 594,53 37,-393 -594,-444 -594,-53z"/>
   <path class="fil1" d="M5089 6466c418,0 465,-607 31,-607 -241,0 -388,291 -220,492 25,29 159,115 189,115z"/>
   <path class="fil1" d="M3236 6132c0,402 404,367 524,220 133,-163 78,-493 -251,-493 -150,0 -273,123 -273,273z"/>
   <path class="fil1" d="M11015 4734c193,0 303,-110 303,-303 0,-267 -334,-380 -509,-206 -186,186 -52,509 206,509z"/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'IrrigationCircuit',
};
</script>

<style scoped>
.fil1 {fill:#FEFEFE}
.fil0 {fill:#56D6D1}
</style>
